module.exports = __webpack_public_path__ + "static/media/person_active.82434046.svg";